export const engagementAppGroupIdPushSettings = "/engagement/:app_group_id/push_settings";
